import { useState, useEffect, useContext } from "react";
import { motion } from "framer-motion";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaShareAlt, FaRegCopy } from "react-icons/fa";
import Footer from "../../includes/footer-tab";
import Preloader from "../Preloader";
import BackButton from "../../includes/Back_btn";
import { AuthContext, shareApp } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

function Refer() {
  const navigate = useNavigate();
  const { isAuthenticated, ReferInfo } = useContext(AuthContext);
  const [preloader, setpreloader] = useState(true);
  const [Info, setInfo] = useState(null);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    ReferInfo((res, ok) => {
      setpreloader(false);
      if (!ok || res.status !== 1) {
        toast.error(ok ? res.msg : "Something went wrong, please try again.");
        return;
      }
      setInfo(res.data);
    });
  }, [ReferInfo]);

  const referLink = Info ? `${window.location.origin}/login?ref=${Info.refer_code}` : "";

  const copy = (text, label) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    textarea.remove();
    toast.success(label + " copied");
  };

  // Phone share sheet: user picks WhatsApp, Telegram, SMS or any other app
  const shareAnywhere = () => {
    shareApp(Info.refer_code);
  };

  return (
    <>
      <Preloader status={preloader} />
      <ToastContainer position="top-right" autoClose={3000} theme="colored" />
      <motion.div
        initial={{ translateX: -100 }}
        animate={{ translateX: 0 }}
        exit={{ translateX: 0 }}
        transition={{ duration: 0.2 }}
      >
        <div className="login header">
          <div className="item">
            <BackButton />
            <p>Refer & Earn</p>
          </div>
        </div>
        {Info && (
          <div className="refer_page">
            <div className="refer_card">
              <p className="refer_label">आपका रेफर कोड</p>
              <div className="refer_row">
                <span className="refer_code">{Info.refer_code}</span>
                <button className="refer_copy" onClick={() => copy(Info.refer_code, "Refer code")}>
                  <FaRegCopy /> Copy
                </button>
              </div>
              <p className="refer_label">आपका रेफर लिंक</p>
              <div className="refer_row">
                <span className="refer_link">{referLink}</span>
                <button className="refer_copy" onClick={() => copy(referLink, "Refer link")}>
                  <FaRegCopy /> Copy
                </button>
              </div>
              <button className="refer_telegram" onClick={shareAnywhere}>
                <FaShareAlt /> दोस्तों को शेयर करो
              </button>
            </div>

            <div className="refer_stats">
              <div>
                <p className="refer_stat_value">{Info.total_referred}</p>
                <p>दोस्त जुड़े</p>
              </div>
              <div>
                <p className="refer_stat_value">₹{Info.total_earned}</p>
                <p>कुल कमाई</p>
              </div>
            </div>

            <div className="refer_card">
              <p className="refer_title">कैसे कमाएं?</p>
              <ul className="refer_rules">
                {Info.referrer_bonus > 0 && (
                  <li>हर नए दोस्त के जुड़ने पर आपको <b>₹{Info.referrer_bonus}</b> बोनस</li>
                )}
                {Info.welcome_bonus > 0 && (
                  <li>आपके कोड से जुड़ने वाले दोस्त को <b>₹{Info.welcome_bonus}</b> वेलकम बोनस</li>
                )}
                {Info.bet_commission > 0 && (
                  <li>दोस्त जितना खेलेगा, उसका <b>{Info.bet_commission}%</b> आपको मिलेगा</li>
                )}
                {Info.deposit_commission > 0 && (
                  <li>दोस्त के हर डिपॉजिट का <b>{Info.deposit_commission}%</b> आपको मिलेगा</li>
                )}
                <li>दोस्त को लॉगिन करते समय आपका रेफर कोड डालना है (लिंक से खोलने पर अपने आप भर जाएगा)</li>
              </ul>
            </div>

            <div className="refer_card">
              <p className="refer_title">आपके दोस्त ({Info.total_referred})</p>
              {Info.referred_users.length === 0 ? (
                <p className="refer_empty">अभी तक कोई दोस्त नहीं जुड़ा। लिंक शेयर करो!</p>
              ) : (
                Info.referred_users.map((user, index) => (
                  <div className="refer_user" key={index}>
                    <span>+91 {user.mobile}</span>
                    <span>{user.date}</span>
                  </div>
                ))
              )}
            </div>
          </div>
        )}
      </motion.div>
      <Footer page="refer" />
    </>
  );
}

export default Refer;
